/* generated by Svelte v3.9.1 */
import {
	SvelteComponent,
	append,
	attr,
	component_subscribe,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	null_to_empty,
	safe_not_equal
} from "svelte/internal";
import Cell from "./Cell.svelte"
import { DEFAULT_CELL_SIZE } from "src/constants";
import { cellSize, gridSize, grid, gameStatus } from "src/store.js"
import c from "classnames"

function add_css() {
	var style = element("style");
	style.id = 'svelte-1tk6kni-style';
	style.textContent = "div.svelte-1tk6kni{border-radius:50%;border:1px solid #796c6c;box-sizing:border-box}.filled.svelte-1tk6kni{background-color:#FBFBF2;opacity:.8}.empty.svelte-1tk6kni{opacity:.3}.pointer.svelte-1tk6kni{cursor:pointer}";
	append(document.head, style);
}

function create_fragment(ctx) {
	var div, div_style_value, dispose;

	return {
		c() {
			div = element("div");
			attr(div, "style", div_style_value = `width: ${ctx.$cellSize}px; height: ${ctx.$cellSize}px;`);
			attr(div, "class", "" + null_to_empty(ctx.classes) + " svelte-1tk6kni");
			dispose = listen(div, "click", ctx.toggleCellState);
		},

		m(target, anchor) {
			insert(target, div, anchor);
		},

		p(changed, ctx) {
			if ((changed.$cellSize) && div_style_value !== (div_style_value = `width: ${ctx.$cellSize}px; height: ${ctx.$cellSize}px;`)) {
				attr(div, "style", div_style_value);
			}

			if (changed.classes) {
				attr(div, "class", "" + null_to_empty(ctx.classes) + " svelte-1tk6kni");
			}
		},

		i: noop,
		o: noop,

		d(detaching) {
			if (detaching) {
				detach(div);
			}

			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $gameStatus, $grid, $cellSize;

	component_subscribe($$self, gameStatus, $$value => { $gameStatus = $$value; $$invalidate('$gameStatus', $gameStatus); });
	component_subscribe($$self, grid, $$value => { $grid = $$value; $$invalidate('$grid', $grid); });
	component_subscribe($$self, cellSize, $$value => { $cellSize = $$value; $$invalidate('$cellSize', $cellSize); });

	

  let { cellState, index } = $$props;


  const toggleCellState = () => {
    if (!$gameStatus) {
      $grid[index] = cellState ? 0 : 1; grid.set($grid);
    }
  }

	$$self.$set = $$props => {
		if ('cellState' in $$props) $$invalidate('cellState', cellState = $$props.cellState);
		if ('index' in $$props) $$invalidate('index', index = $$props.index);
	};

	let classes;

	$$self.$$.update = ($$dirty = { cellState: 1, $gameStatus: 1 }) => {
		if ($$dirty.cellState || $$dirty.$gameStatus) { $$invalidate('classes', classes = c({
        'filled': cellState,
        'empty': !cellState,
        'pointer': !$gameStatus
      })) }
	};

	return {
		cellState,
		index,
		toggleCellState,
		classes,
		$cellSize
	};
}

class Component extends SvelteComponent {
	constructor(options) {
		super();
		if (!document.getElementById("svelte-1tk6kni-style")) add_css();
		init(this, options, instance, create_fragment, safe_not_equal, ["cellState", "index"]);
	}
}

export default Component;